// import enterpriseLsList from '../components/enterpriseLs/enterpriseLsList.vue'

export default [
    { 
        path: 'enterpriseLs/enterpriseLsList', 
        component: resolve => require(['@/components/enterpriseLs/enterpriseLsList'],resolve),
        name:'EnterpriseLsList',
        meta:{
            id:'833',
            node:'enterpriseLs',
            url:'enterpriseLsList',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/enterpriseLs.js